import mushinlabFullLogo from '../../assets/images/ARC Logo.png';
import mushinlabHalfLogo from '../../assets/images/WHITE.png';
import logo from '../../assets/images/DP Mushin Labs.png';


interface ImagesType {
  mushinlabFullLogo: string;
  mushinlabHalfLogo: string;
  companyImg: string;
  moduleCompanyImgHeader: string;
  companyLogo: string;
  logoWhite: string;
}

export const images: ImagesType = {
  mushinlabFullLogo: mushinlabFullLogo,
  mushinlabHalfLogo: mushinlabHalfLogo,
  companyImg: `https://mushin-labs.s3.ap-south-1.amazonaws.com/SL-Fasteners/SL+Logo.png`,
  moduleCompanyImgHeader: `https://mushin-labs.s3.ap-south-1.amazonaws.com/SL-Fasteners/SL+Logo.png`,
  companyLogo: logo,
  logoWhite: mushinlabHalfLogo,
};

export const textInputs: {
  companyName: string;
} = {
  companyName: 'SL FASTENERS PVT. LTD.',
};
